import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  // Usar Injector para evitar dependência circular com AuthService
  private authService?: AuthService;

  constructor(private injector: Injector) {}

  private getAuthService(): AuthService {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }
    return this.authService;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Obtém o tenantId do AuthService (que gerencia armazenamento em localStorage)
    const tenantId = this.getAuthService().getTenant();

    // Se há um tenantId, adiciona o header X-Tenant-ID a TODAS as requisições
    if (tenantId) {
      console.log('[TenantInterceptor] adicionando X-Tenant-ID:', tenantId, 'para', request.url);
      const cloned = request.clone({
        setHeaders: {
          'X-Tenant-ID': tenantId,
        },
      });
      return next.handle(cloned);
    }

    // Se é a rota de login e não há tenantId, não adiciona o header
    // Isso permite que a seleção de empresa no frontend defina o tenantId
    if (request.url.includes('/api/auth/login')) {
      console.log('[TenantInterceptor] requisição de login sem tenantId definido, continuando sem header');
      return next.handle(request);
    }

    // Para outras requisições sem tenantId, avisa no console
    console.log('[TenantInterceptor] nenhum tenantId encontrado para', request.url);
    return next.handle(request);
  }
}
